import axios from "../../service";
// import { utility } from "./utility";
import alert from "@/_helpers/alert";
import moment from "moment";
import fn from "@/helpers/utility";
import { OrderService } from "../resources";
export const state = {
  keyAuth: {
    key: "order_flag",
    keyAdvance: "advanced_order_flag"
  },
  originSummary: {},
  logistic: [],
  logisticSummery: {},
  ordermulti: [],
  claimorder: [],
  idOrder: null,
  orderMarkUp: {
    all: [],

    summary: {},
    detailSelect: [],
    orderTimelineOrder: []
  },
  storeSelectPickup: {},

  orderCommission: {
    id: "",
    data: [],
    account: [],
    summary: {
      cancel_amount: 0,
      match_with_partner_amount: 0,
      month_total: 0,
      not_delivered_amount: 0,
      partners: [],
      return_amount: 0,
      sent_successfully_amount: 0
    },
    timeLine: [],
    apiLog: []
  },
  statusModal: false,
  OrderReport: {
    report: [],
    total: 0,
    count_not_delivered: 0,
    count_return_back: 0,
    count_cancel: 0,
    count_sent_successfully: 0,
    count_match_with_partner_flag: 0,
    data_now: 0,
    count_order: [],
    journy: [],
    wallet_transection: [],
    costWithRecal: 0,
    costWithOutRecal: 0
  },
  OrderReportGraph: [
    { overall: 0 },
    {
      success_bar: 0,
      cancel_bar: 0,
      value_bars: 0
    }
  ],
  logistic: [],
  logisticSummery: {},
  ordermulti: [],
  claimorder: []
};

export const mutations = {
  SET_ORIGIN_SUMMARY(state, newValue) {
    state.originSummary = newValue;
  },

  INIT_SET_SELECT_PICKUP(state, newValue) {
    state.storeSelectPickup = newValue;
  },
  INIT_TIMELINE_ORDER(state, newValue) {
    state.orderMarkUp.orderTimelineOrder = newValue.data
      .map(value => {
        return {
          title: value.event_title,
          // fn.orderStatus.thai[value.event_title] || "-",
          // value.event_title,
          from: new Date(value.event_dt),
          description: value.event_desc.detail,
          color: "",
          event_type: value.event_type
        };
      })
      .filter(value => {
        ["create", "tracking", "cancel"].includes(value.event_type);
      });
  },

  INIT_LOGISTIC(state, newValue) {
    state.logistic = newValue.map(o => {
      return {
        id: o.partner_id,
        name: o.partner_name,
        image: o.partner_pic,
        price: o.price,
        normal_price: o.normal_price,
        partner_id: o.partner_id,
        partner_code: o.partner_code,
        ws: o.ws
      };
    });
  },
  INIT_SUMMARY(state, newValue) {
    state.logisticSummery = newValue;
  },
  INIT_CLAIM_ORDER(state, newValue) {
    if (newValue) {
      state.claimorder = newValue;
      if (newValue.OrderClaim != undefined) {
        for (let index = 0; index < newValue.OrderClaim.length; index++) {
          if (newValue.OrderClaim[index].image != null) {
            for (let index_arr = 0; index_arr < newValue.OrderClaim[index].image.length; index_arr++) {
              newValue.OrderClaim[index].image[index_arr].file =
                process.env.VUE_APP_IMAGE_CENTER +
                "/claimorder/" +
                newValue.OrderClaim[index].id +
                "/" +
                newValue.OrderClaim[index].token_img +
                "?file=" +
                newValue.OrderClaim[index].image[index_arr].file;
            }
          }
        }
      }
    }
  },

  INIT_ID_COMMISSION(state, newValue) {
    state.orderCommission.id = newValue;
  },
  INIT_API_LOG(state, newValue) {
    state.orderCommission.apiLog = newValue;
  },
  INIT_STATUS_MODAL(state, newValue) {
    state.statusModal = newValue;
  },
  INIT_TIMELINE_COMMISSION(state, newValue) {
    state.orderCommission.timeLine = newValue;
  },
  INIT_TIMELINE_ORDER(state, newValue) {
    state.orderMarkUp.orderTimelineOrder = newValue.data
      .map(value => {
        return {
          // title: value.event_title,
          title: fn.orderStatus.thai[`${value.event_title}`] || "-",
          from: new Date(value.event_dt),
          description: value.event_desc.detail,
          color: "",
          event_type: value.event_type
        };
      })
      .filter(value => {
        return ["create", "tracking", "cancel"].includes(value.event_type);
      });
  },
  INIT_ACCOUNT_COMMISSION(state, newValue) {
    state.orderCommission.account = newValue;
    state.orderCommission.account.data = state.orderCommission.account.data.filter((value, index) => {
      if (index <= 4) {
        return true;
      } else {
        return false;
      }
    });
  },
  INIT_SUMMARY_ORDER_Search(state, newValue) {
    state.orderCommission.data = newValue.table;
  },

  INIT_SUMMARY_ORDER(state, newValue) {
    state.orderCommission.data = newValue.table;
    state.orderCommission.summary = newValue.summary;
  },
  INIT_LOGISTIC(state, newValue) {
    state.logistic = newValue.map(o => {
      return {
        id: o.partner_id,
        name: o.partner_name,
        image: o.partner_pic,
        price: o.price,
        normal_price: o.normal_price,
        partner_id: o.partner_id,
        partner_code: o.partner_code,
        ws: o.ws
      };
    });
  },
  INIT_SUMMARY(state, newValue) {
    state.logisticSummery = newValue;
  },
  INIT_REPORT_ORDER(state, newValue) {
    if (newValue.report.length == 0) {
      state.OrderReport.report = newValue.report;
      state.OrderReport.total = newValue.report.length;
    } else {
      state.OrderReport = newValue;
    }
  },
  INIT_REPORT_ORDER_DETAIL(state, newValue) {
    if (newValue.journy != undefined) {
      state.OrderReport.logs = newValue.journy;
    }
    if (newValue.transactions != undefined) {
      state.OrderReport.transactions = newValue.transactions;
    }
  },
  INIT_REPORT_ORDER_GRAPH(state, newValue) {
    state.OrderReportGraph = newValue;
  },
  COD_REPORT_ORDER(state, newValue) {
    if (newValue.length > 0) {
      for (let index = 0; index < newValue.length; index++) {
        if (newValue[index].success == true) {
          let index_arr = state.OrderReport.report.findIndex(o => {
            return o.partner_awb_no == newValue[index].tracking_no;
          });

          if (index_arr != -1) {
            let object = {
              cod_received_flag: 1,
              cod_received_dt: newValue[index].cod_received_dt
            };
            Object.assign(state.OrderReport.report[index_arr], object);
          }
        }
      }
    }
  },
  CALCULATE_REPORT_COST_ORDER(state, newValue) {
    if (newValue.length > 0) {
      for (let index = 0; index < newValue.length; index++) {
        if (newValue[index].success == true) {
          let index_arr = state.OrderReport.report.findIndex(o => {
            return o.partner_awb_no == newValue[index].tracking_no;
          });

          if (index_arr != -1) {
            let object = {
              match_with_partner_flag: 1,
              match_with_partner_dt: newValue[index].datenow
            };
            Object.assign(state.OrderReport.report[index_arr], object);
          }
        }
      }
    }
  },
  CALCULATE_REPORT_ORDER(state, newValue) {
    if (newValue.length > 0) {
      for (let index = 0; index < newValue.length; index++) {
        if (newValue[index].success == true) {
          let index_arr = state.OrderReport.report.findIndex(o => {
            return o.partner_awb_no == newValue[index].tracking_no;
          });

          if (index_arr != -1) {
            let object = {
              paid_to_partner_flag: 1
            };
            Object.assign(state.OrderReport.report[index_arr], object);
          }
        }
      }
    }
  },
  CANCEL_ORDER(state, newValue) {
    let index_arr = state.OrderReport.report.findIndex(o => {
      return o.ws_booking_ref == newValue.ws_booking_ref;
    });
    let object = {
      cancel_flag: 1
    };
    Object.assign(state.OrderReport.report[index_arr], object);
  },
  INIT_CLAIM_ORDER(state, newValue) {
    state.claimorder = newValue;
    if (newValue.OrderClaim != undefined) {
      for (let index = 0; index < newValue.OrderClaim.length; index++) {
        if (newValue.OrderClaim[index].image != null) {
          for (let index_arr = 0; index_arr < newValue.OrderClaim[index].image.length; index_arr++) {
            if (!newValue.OrderClaim[index].token_img) {
              newValue.OrderClaim[index].image[index_arr].file =
                process.env.VUE_APP_URL_IMAGE +
                "/claimorder/" +
                newValue.OrderClaim[index].id +
                "/" +
                "admin" +
                "?file=" +
                newValue.OrderClaim[index].image[index_arr].file;
            } else {
              newValue.OrderClaim[index].image[index_arr].file =
                process.env.VUE_APP_URL_IMAGE +
                "/claimorder/" +
                newValue.OrderClaim[index].id +
                "/" +
                newValue.OrderClaim[index].token_img +
                "?file=" +
                newValue.OrderClaim[index].image[index_arr].file;
            }
          }
        }
      }
    }
  },
  CREATE_CLAIM_ORDER(state, newValue) {
    state.claimorder.OrderClaim = newValue.query;
    for (let index = 0; index < newValue.query.length; index++) {
      if (newValue.query[index].image != null) {
        for (let index_arr = 0; index_arr < newValue.query[index].image.length; index_arr++) {
          if (newValue.query[index].token_img) {
            newValue.query[index].image[index_arr].file =
              process.env.VUE_APP_URL_IMAGE +
              "/claimorder/" +
              newValue.query[index].id +
              "/" +
              newValue.query[index].token_img +
              "?file=" +
              newValue.query[index].image[index_arr].file;
          } else {
            newValue.query[index].image[index_arr].file =
              process.env.VUE_APP_URL_IMAGE +
              "/claimorder/" +
              newValue.query[index].id +
              "/" +
              "admin" +
              "?file=" +
              newValue.query[index].image[index_arr].file;
          }
        }
      }
    }
    // state.claimorder.claimOrder.push({})
  },
  INIT_ORDER_MARKUP_ALL(state, newValue) {
    try {
      state.orderMarkUp.all = newValue.all.data;
      state.orderMarkUp.summary = newValue.summary.data;
    } catch (err) {
      console.error(err.message);
    }
  },

  INIT_ORDER_MARKUP_DATA_ONLY(state, newValue) {
    try {
      state.orderMarkUp.all = newValue.all.data;
    } catch (err) {
      console.error(err.message);
    }
  },

  INIT_ORDER_MARKUP_SUMMARY(state, newValue) {
    try {
      state.orderMarkUp.summary = newValue.summary.data;
    } catch (err) {
      console.error(err.message);
    }
  },

  INIT_DETAIL_SELECT_MARKUP(state, newValue) {
    state.idOrder = newValue;
    // state.orderMarkUp.detailSelect = newValue;
  },
  INIT_ORDER_MARKUP_SELECT(state, newValue) {
    state.orderMarkUp.detailSelect = newValue;
  },
  INIT_ID_Order(state, newValue) {
    state.idOrder = newValue;
  }
};

export const getters = {
  PermissionFlag(state) {
    return fn.PermissionFlag(state.keyAuth.keyAdvance);
  }
};

export const actions = {
  clearAllState({ commit }) {
    commit("INIT_LOGISTIC", []);
    commit("INIT_SUMMARY", {});
  },
  // async logisticCalculate({ commit }, data) {
  //     try {
  //         let resp = await axios.post("/user/partner/suggest", {
  //             ...data,
  //         });
  //         if (!resp) throw "เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง!";
  //         if (!resp.data.length) throw "ไม่พบข้อมูลขนส่งที่เหมาะสม";
  //         if (resp.data.length > 0 && !data.multiorder) {
  //             commit("INIT_LOGISTIC", resp.data[0].partner);
  //         }
  //         return { status: true, data: resp.data[0].partner };
  //     } catch (error) {
  //         commit("INIT_LOGISTIC", []);
  //         return { status: false, err: error };
  //     }
  // },

  // async caculateSummary({ commit }, data) {
  //     try {
  //         let resp = await axios.post("/user/partner/suggest", {
  //             ...data,
  //         });
  //         if (!resp) throw "เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง!";
  //         commit("INIT_SUMMARY", resp.data[0].partner[0]);
  //         return { status: true };
  //     } catch (error) {
  //         commit("INIT_SUMMARY", {});
  //         return { status: false, err: error };
  //     }
  // },

  // async createOrder({ commit }, data) {
  //     try {
  //         let resp = await axios.post("/user/order/create", {
  //             ...data,
  //         });
  //         if (!resp) throw "เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง!";
  //         commit("auth/UPDATE_USER_CREDIT", { credit: resp.data[0].credit, bonus: resp.data[0].bonus }, { root: true });
  //         return { status: true, data: resp.data[0] };
  //     } catch (err) {
  //         return { status: false, err: err };
  //     }
  // },

  // async cancelOrder(_, data) {
  //     try {
  //         let resp = await axios.post("/user/order/cancel", {
  //             ...data,
  //         });
  //         if (!resp) throw "เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง!";
  //         return { status: true };
  //     } catch (err) {
  //         return { status: false, err: err };
  //     }
  // },

  // async GetClaimOrder({ commit }, data) {
  //     try {

  //         let resp = await axios.get("/center/claim-order", {
  //             params: {
  //                 ...data,
  //             },
  //         });
  //         commit("INIT_CLAIM_ORDER", resp.data);
  //         if (!resp) throw "เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง!";
  //         return { status: true };
  //     } catch (err) {
  //         return { status: false, err: err };
  //     }
  // },

  async loadApiLog({ commit }, id = 0) {
    try {
      let resp = await OrderService.apiGetLog(id);
      return { status: true, ...resp };
    } catch (e) {
      return { status: false, data: {} };
    }
  },
  async loadTimeline({ commit }, id) {
    let resp = await OrderService.apiGetTimeline(id);
    commit("INIT_TIMELINE_COMMISSION", resp.data);
  },

  async loadAccount({ commit }, data) {
    let resp = await OrderService.apiGetAccount(data);
    commit("INIT_ACCOUNT_COMMISSION", resp);
  },

  async loadCommissionOrderSearch({ commit }, data) {
    try {
      let dataHeader = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      };

      let resp = await axios
        .get(`${process.env.VUE_APP_ENDPOINT_BACKEND}/admin-api/v1/commission-orders`, {
          params: {
            search: data.search,
            partner_id: data.parent_id,
            account_id: data.account_id,
            complete_flag: data.complete_flag,
            cod_flag: data.cod_flag,
            from_date: data.from_date == "0" ? null : data.from_date,
            to_date: data.to_date == "0" ? null : data.to_date,
            page: data.page,
            limit: data.perPage
          },
          ...dataHeader
        })
        .then(success => {
          return success;
        })
        .catch(err => console.error(err.message));

      let summary = await axios.get(`${process.env.VUE_APP_ENDPOINT_BACKEND}/admin-api/v1/dashboard/commission-orders`, {
        params: {
          search: data.search,
          partner_id: data.parent_id,
          account_id: data.account_id,
          complete_flag: data.complete_flag,
          cod_flag: data.cod_flag,
          from_date: data.from_date == "0" ? null : data.from_date,
          to_date: data.to_date == "0" ? null : data.to_date
        },
        ...dataHeader
      });

      commit("INIT_SUMMARY_ORDER", { table: resp.data, summary });
    } catch (err) {
      console.error(err.message, "Error-Search");
    }
  },

  async loadCommissionOrder({ commit }, data) {
    try {
      let dataHeader = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      };
      // ${process.env.VUE_APP_ENDPOINT_BACKEND}
      let table = await axios.get(`${process.env.VUE_APP_ENDPOINT_BACKEND}/admin-api/v1/commission-orders`, {
        params: {
          page: "1",
          limit: data.perPage,
          //   sort: "ASC",
          from_date: data.start == "0" ? null : data.start,
          to_date: data.end == "0" ? null : data.end
        },
        ...dataHeader
      });
      let summary = await axios.get(`${process.env.VUE_APP_ENDPOINT_BACKEND}/admin-api/v1/dashboard/commission-orders`, {
        params: {
          //   sort: "ASC",
          from_date: data.start == "0" ? null : data.start,
          to_date: data.end == "0" ? null : data.end
        },
        ...dataHeader
      });

      commit("INIT_SUMMARY_ORDER", { table: table.data, summary });
    } catch (err) {
      console.error(err.message, "Error-LoadCommissionOrder");
    }
  },

  async loadSummary() {
    try {
      let reqOptions = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      };
      let resp = axios
        .post(`${process.env.VUE_APP_ENDPOINT_BACKEND}/admin-api/v1/dashboard/shipment-orders`, reqOptions)
        .then(value => {})
        .catch(err => {
          console.error(err, "Error");
        });
      // let resp = await axios.post(reqOptions);
      if (!resp) {
        throw "ไม่พบข้อมูล";
      }
    } catch (e) {
      console.error("Error-LoadSummary", e.message);
    }
  },
  clearAllState({ commit }) {
    commit("INIT_LOGISTIC", []);
    commit("INIT_SUMMARY", {});
  },

  // async logisticCalculate({ commit }, data) {
  //   try {
  //     let resp = await axios.post("/admin/partner/suggest", {
  //       ...data
  //     });
  //     if (!resp) throw "เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง!";
  //     if (!resp.data.length) throw "ไม่พบข้อมูลขนส่งที่เหมาะสม";
  //     if (resp.data.length > 0 && !data.multiorder) {
  //       commit("INIT_LOGISTIC", resp.data[0].partner);
  //     }
  //     return { status: true, data: resp.data[0].partner };
  //   } catch (error) {
  //     commit("INIT_LOGISTIC", []);
  //     return { status: false, err: error };
  //   }
  // },

  // async caculateSummary({ commit }, data) {
  //   try {
  //     let resp = await axios.post("/admin/partner/suggest", {
  //       ...data
  //     });
  //     if (!resp) throw "เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง!";
  //     commit("INIT_SUMMARY", resp.data[0].partner[0]);
  //     return { status: true };
  //   } catch (error) {
  //     commit("INIT_SUMMARY", {});
  //     return { status: false, err: error };
  //   }
  // },

  // async createOrderByadmin({ commit }, data) {
  //   try {
  //     let resp = await axios.post("/admin/order/create", {
  //       ...data
  //     });
  //     if (!resp) throw "เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง!";
  //     commit("auth/UPDATE_USER_CREDIT", { credit: resp.data[0].credit, bonus: resp.data[0].bonus }, { root: true });
  //     return { status: true, data: resp.data[0] };
  //   } catch (err) {
  //     return { status: false, err: err };
  //   }
  // },

  // async fetchReportOrder({ commit }, data) {
  //   try {
  //       return
  //     let resp = await axios.get("/admin/report/order", {
  //       params: {
  //         ...data
  //       }
  //     });
  //     if (!resp) throw "เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง!";
  //     commit("INIT_REPORT_ORDER", resp.data);
  //     return { status: true, data: resp.data };
  //   } catch (err) {
  //     return { status: false, err: err };
  //   }
  // },
  // async fetchReportOrderDetail({ commit }, data) {
  //   try {
  //       throw('Error')
  //     let resp = await axios.get("/admin/report/order-detail", {
  //       params: {
  //         ...data
  //       }
  //     });
  //     if (!resp) throw "เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง!";
  //     commit("INIT_REPORT_ORDER_DETAIL", resp.data);
  //     return { status: true, data: resp.data };
  //   } catch (err) {
  //     return { status: false, err: err };
  //   }
  // },

  // async cancelOrderByadmin({ commit }, data) {
  //   try {
  //     let resp = await axios.post("/admin/order/cancel", {
  //       ws_booking_ref: data.ws_booking_ref,
  //       remark: data.remark,
  //       cancel_flag: data.cancel_flag
  //     });
  //     if (!resp) throw "เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง!";
  //     commit("CANCEL_ORDER", data);

  //     return { status: true };
  //   } catch (err) {
  //     return { status: false, err: err };
  //   }
  // },

  // async fetchReportOrderGraph({ commit }, data) {
  //   try {
  //     let resp = await axios.get("/user/dashboard", {
  //       params: {
  //         ...data
  //       }
  //     });
  //     if (!resp) throw "เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง!";
  //     commit("INIT_REPORT_ORDER_GRAPH", resp.data);
  //     return { status: true, data: resp.data };
  //   } catch (err) {
  //     return { status: false, err: err };
  //   }
  // },

  // async CalculateCod({ commit }, data) {
  //   try {
  //     let resp = await axios.post("/admin/import/cod", {
  //       list: data.order_list,
  //       validate: data.validate,
  //       dateUpload: data.dateUpload
  //     });
  //     commit("COD_REPORT_ORDER", resp.data);

  //     if (!resp) throw "เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง!";
  //     return { status: true, data: resp.data };
  //   } catch (err) {
  //     return { status: false, err: err };
  //   }
  // },

  // async CalculateCost({ commit }, data) {
  //   try {
  //     let resp = await axios.post("/admin/RecalculateAdmin", {
  //       order_list: data.order_list,
  //       validate: data.validate
  //     });
  //     commit("CALCULATE_REPORT_COST_ORDER", resp.data);

  //     if (!resp) throw "เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง!";
  //     return { status: true, data: resp.data };
  //   } catch (err) {
  //     return { status: false, err: err };
  //   }
  // },

  // async CalculateOrder({ commit }, data) {
  //   try {
  //     let resp = await axios.post("/admin/import/order", {
  //       list: data.order_list
  //     });
  //     commit("CALCULATE_REPORT_ORDER", resp.data);

  //     if (!resp) throw "เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง!";
  //     return { status: true, data: resp.data };
  //   } catch (err) {
  //     return { status: false, err: err };
  //   }
  // },

  // async GetClaimOrder({ commit }, data) {
  //   try {
  //     // /center/claim-order
  //     //   http://localhost:8060/api/v1/shipment-orders/1220/claims
  //     let resp = await axios.get("/center/claim-order", {
  //       params: {
  //         ...data
  //       }
  //     });
  //     commit("INIT_CLAIM_ORDER", resp.data);
  //     if (!resp) throw "เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง!";
  //     return { status: true, data: resp.data };
  //   } catch (err) {
  //     return { status: false, err: err };
  //   }
  // },

  // async CreateClaimOrder({ commit }, data) {
  //   try {
  //     let formData = new FormData();

  //     if (data.claimOrderImage != null && data.claimOrderImage != undefined) {
  //       for (let v of data.claimOrderImage) {
  //         formData.append("ClaimOrderImage", v.file);
  //       }
  //     }
  //     formData.append(
  //       "data",
  //       JSON.stringify({
  //         amount: data.amount,
  //         description: data.description,
  //         order_id: data.order_id,
  //         type: data.type,
  //         refund: data.refund
  //       })
  //     );
  //     let resp = await axios.post("/admin/create-claim-order", formData);
  //     commit("CREATE_CLAIM_ORDER", resp.data);
  //     if (!resp) throw "เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง!";
  //     return { status: true, data: resp.data };
  //   } catch (err) {
  //     return { status: false, err: err };
  //   }
  // },

  async LoadOrderMarkUpAll({ commit, state }, data) {
    let dataSearch;
    if (data.search) {
      dataSearch = {
        search: data.search,
        page: data.page,
        limit: data.limit,
        sort:'DESC'
      };
    } else {
      dataSearch = data;
    }
    let resp = await OrderService.apiGetOrderAll(dataSearch);

    let dataToken = JSON.parse(JSON.stringify(data));
    delete dataToken.page;
    delete dataToken.limit;
    delete dataToken.search;
    delete dataToken.shipment_status;
    delete dataToken.sort;
    delete dataToken.print_flag;
    delete dataToken.insurance;

    let dataTime = dataToken;
    delete dataTime.status;
    if (data.claim_flag) {
      if (data.search) {
        dataTime.claim_flag = "1,2";
      } else {
        dataTime.claim_flag = data.claim_flag;
      }
    }
    //
    if (JSON.stringify(state.originSummary) != JSON.stringify(dataTime)) {
      commit("SET_ORIGIN_SUMMARY", dataTime);
      try {
        let respSummary = await OrderService.apiGetOrderAllSummary(dataTime);

        if (!resp) {
          alert.error("เชื่อมต่อ server ไม่ได้");
          return { status: false, data: {} };
        } else {
          commit("INIT_ORDER_MARKUP_ALL", { all: resp, summary: respSummary });
          return { status: true, data: resp, summary: respSummary };
        }
      } catch (err) {
        console.error(err.message, "summary");
        return { status: false, err: err };
      }
    } else {
      commit("INIT_ORDER_MARKUP_DATA_ONLY", { all: resp });
      return { status: true, data: resp };
    }
  },

  async getOrderMarkupByPartnerAwbNo({ commit }, partnerAwbNo) {
    try {
      let resp = await OrderService.apiGetOrderAll({
        partner_awb_no: partnerAwbNo,
        page: 1,
        limit: 1,
        sort: 'DESC'
      });
      return resp.data;
    } catch (err) {
      console.error(err.message, "getOrderMarkupByPartnerAwbNo");
      return [];
    }
  },

  async loadSummaryDefault({ commit }, dataTime) {
    try {
      let respSummary = await OrderService.apiGetOrderAllSummary(dataTime);
      commit("INIT_ORDER_MARKUP_SUMMARY", { summary: respSummary });
      return { status: true, summary: respSummary };
    } catch (err) {
      console.error(err.message, "summary");
      return { status: false, err: err };
    }
  },

  async LoadTransection({ commit }, id) {
    try {
      let resp = await OrderService.apiGetTransection();
      return { status: true, ...resp };
    } catch (e) {
      return { status: false, err: err };
    }
  },
  async GetOrderMarkup({ commit }, data) {
    try {
      let resp = await this.apiGetOrderMarkup(data);
      commit("INIT_ORDER_MARKUP_SELECT", resp);
      return { status: true, data: resp };
    } catch (e) {
      return { status: false, err: err };
    }
  },

  async LoadOrderMarkUpSelect({ commit }, id) {
    let resp = await OrderService.apiGetOrderMarkUpSelect(id);
    if (!resp) {
      alert.error("เชื่อมต่อ sever ไม่ได้");
    }

    commit("INIT_ORDER_MARKUP_SELECT", resp);
  },

  async LoadSelectOrderMarkup({ commit }, data) {
    try {
      // utility.ckErr();
      //
      let resp = await OrderService.apiGetSelectOrderMarkup();
      commit("INIT_ORDER_MARKUP_SELECT", resp);
      return { status: true, data: resp };
    } catch (e) {
      return { status: false, err: err };
    }
  },

  async GetPickupAddresss({ commit }, search = null) {
    try {
      let resp = await OrderService.apiGetPickupAddresss(search);
      return { status: true, ...resp };
    } catch (err) {
      return { status: false, err: err };
    }
  },

  async GetBoxpackage() {
    try {
      let resp = await OrderService.apiGetBoxpackage();
      return { status: true, data: resp.data };
    } catch (e) {
      return { status: false, err: err };
    }
  },

  async LoadPickupTransport() {
    try {
      let resp = await OrderService.apiGetPickupTransport();
      return { status: true, data: resp };
    } catch (e) {
      return { status: false, err: err };
    }
  },

  async LoadReceiveAddress() {
    try {
      //
      let resp = await OrderService.apiGetReceiveAddress();
      return { status: true, ...resp };
    } catch (e) {
      return { status: false, err: err };
    }
  },

  async LoadEstimateShippingPrice({ commit }, data) {
    try {
      //
      let resp = await OrderService.apiCreateEstimateShippingPrice(data);
      return { status: true, ...resp };
    } catch (e) {
      return { status: false, err: e };
    }
  },

  async CreateOrderNew({ commit }, data) {
    try {
      let resp = await OrderService.apiCreateOrderNew(data);
      return { status: true, ...resp };
    } catch (err) {
      return { status: false, err: err };
    }
  },

  async CreateOrderNewInsurance({ commit }, data) {
    try {
      let resp = await OrderService.apiCreateOrderNewInsurance(data);
      return { status: true, ...resp };
    } catch (err) {
      return { status: false, err: err };
    }
  },


  async CreateOrderMultiple({ commit }, data) {
    try {
      let resp = await OrderService.apiCreateOrderMultiple(data);
      return { status: true, ...resp };
    } catch (err) {
      return { status: false, err: err };
    }
  },

  async loadTimelineOrder({ commit }, id) {
    let resp = await OrderService.apiGetTimelineOrder(id);
    commit("INIT_TIMELINE_ORDER", resp);
    return { status: true, ...resp };
  },

  async LoadTimeLinePopupstepTwo({ commit }, id) {
    try {
      let resp = await OrderService.apiGetTimeLinePopupstepTwo(id);
      return { status: true, ...resp };
    } catch (err) {
      return { status: false, err: err };
    }
  },

  async addOrderSave({ commit }, data) {
    try {
      let resp = await OrderService.apiCreateOrderSave(data);
      return { status: true, ...resp };
    } catch (err) {
      return { status: false, err: err };
    }
  },

  async loadClaimType() {
    try {
      let resp = await OrderService.apiGetClaimType();
      return { status: true, ...resp };
    } catch (err) {
      return { status: false, err: err };
    }
  },

  async loadWelletTransection({ commit }, id) {
    try {
      let resp = await OrderService.apiGetWelletTransection(id);
      return { status: true, ...resp };
    } catch (err) {
      return { status: false, err: err };
    }
  },
  async getPriceInsurance({ commit }, data) {
    try {
      let resp = await OrderService.apiGetPriceInsurance(data);
      return { status: true, ...resp };
    } catch (err) {
      return { status: false, err: err };
    }
  },


  async loadApiCommission({ commit }, id = 0) {
    try {
      let resp = await OrderService.apiGetCommission(id);
      return { status: true, ...resp };
    } catch (e) {
      return { status: false, data: {} };
    }
  },

  async cancelOrder({ commit }, data = 0) {
    try {
      let resp = await OrderService.apiEditcancelOrder(data);
      return { status: true, ...resp };
    } catch (err) {
      return { status: false, err: err };
    }
  },

  async uploadfile({ commit, dispatch, getters }, data) {
    try {
      let resp = await axios({
        method: "POST",
        url: `${process.env.VUE_APP_ENDPOINT_BACKEND}/client/v1/upload/${data.idAccount}/file`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "multipart/form-data"
        },
        data: data.formData
      })
        .then(success => {
          return success;
        })
        .catch(err => {
          console.error(err.message, "message-upload-profile");
          console.error(err, "err");
          alert.error(err.message);
          return err.message;
        });
      if (!resp) {
        return { status: false, data: {} };
      } else {
        return resp?.data;
      }
    } catch (err) {
      console.error(err.message, "err.message");
      alert.error("เกิดขอผิดพลาด");
    }
  },

  async getPartnerAll({ commit, dispatch, getters }, data) {
    try {
      let resp = await OrderService.apiGetPartnerate();
      return { status: true, ...resp };
    } catch (err) {
      console.error(err.message, "err.message");
      alert.error("เกิดขอผิดพลาด");
    }
  },

  async getPickupOrder({ commit }, data) {
    try {
      let resp = await OrderService.apiGetPickupOrder(data);
      if (!resp) {
        return { status: false, data: {} };
      }
      return { status: true, data: resp };
    } catch (err) {
      return { status: false, err: err };
    }
  },
  async getPickupSummary({ commit }, data) {
    try {
      let resp = await OrderService.apiGetPickupSummary(data);
      return { status: true, ...resp };
    } catch (err) {
      return { status: false, err: err };
    }
  },

  async getPickupOrderByIdToken({ commit }, id) {
    try {
      let resp = await OrderService.apiGetPickupOrderById(id);
      return { status: true, ...resp };
    } catch (err) {
      return { status: false, err: err };
    }
  },

  async getAccountProfile({ commit }, id) {
    try {
      let resp = await axios({
        method: "GET",
        url: `${process.env.VUE_APP_ENDPOINT_BACKEND}/client/v1/accounts`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      })
        .then(success => {
          return success;
        })
        .catch(err => {
          return err;
        });
      if (!resp) {
        return { status: false, data: {} };
      }
      return { status: true, data: resp };
    } catch (err) {
      return { status: false, err: err };
    }
  },

  async getHistoryInsuranceOrder({ commit }, id) {
    try {
      let resp = await OrderService.apiGetHistoryInsuranceOrder(id);
      return { status: true, ...resp };
    } catch (err) {
      return { status: false, err: err };
    }
  },


  async updatePickup({ commit }, data) {
    try {
      let resp = await OrderService.apiEditupdatePickup(data);
      return { status: true, ...resp };
    } catch (err) {
      console.error(err.meessage, "message-catch");
      return { status: false, err: err };
    }
  },

  async getPartnerList({ commit }, id) {
    try {
      let resp = await OrderService.apiGetPartnerList();
      return { status: true, ...resp };
    } catch (e) {
      return { status: false, err: err };
    }
  },

  ////////////// ocd Order
  async getCodOrder({ commit }, data) {
    try {
      let resp = await OrderService.apiGetCodOrder(data);
      return { status: true, ...resp };
    } catch (e) {
      return { status: false, err: err };
    }
  },

  async getCodOrderSummary({ commit }, data) {
    try {
      let resp = await OrderService.apiGetCodOrderSummary(data);
      return { status: true, ...resp };
    } catch (e) {
      return { status: false, err: err };
    }
  },

  async getCodOrderSummaryMoney({ commit }, data) {
    try {
      let resp = await OrderService.apiGetCodOrderSummaryMoney(data);
      return { status: true, ...resp };
    } catch (e) {
      return { status: false, err: err };
    }
  },

  async getDocumentCreditNote({ commit }, data) {
    try {
      let resp = await OrderService.apiGetDocumentCreditNote(data);
      return { status: true, ...resp };
    } catch (err) {
      console.error(err.meessage, "message-catch");
      return { status: false, err: err };
    }
  },

  async exportOrderCodFile({ commit }, data) {
    try {
      let resp = await axios({
        method: "GET",
        url: `${process.env.VUE_APP_ENDPOINT_BACKEND}/client/v2/reports/shipment-orders/cod/export`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          Accept: "application/json"
        },
        responseType: "blob",
        timeout: 300000,
        maxContentLength: 1073741824,
        params: data
      })
        .then(response => {
          let dataStr = fn.cutFileName(response.headers["content-disposition"]);
          let format = dataStr.split(".");
          format = format[format.length - 1];
          let url;
          if (response?.headers) {
            if (format == "xlsx") {
              url = window.URL.createObjectURL(new Blob([response.data]));
            } else if (format == "csv") {
              var BOM = "\uFEFF"; // utf-8 ใส่ตัวนี้
              url = window.URL.createObjectURL(new Blob([BOM + response.data]));
            } else {
              alert.error("export file ไมไ่ด้");
            }
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", dataStr);
            document.body.appendChild(link);
            link.click();
          }
        })
        .catch(err => {
          console.error(err.message, "message");
          return err.message;
        });
      if (typeof resp == "string") {
        return { status: false, data: {}, message: resp };
      } else {
        return { status: true, data: resp };
      }
    } catch (err) {
      console.error(err.message, "message");
    }
  },

  async exportExcelShipmentOrder({ commit }, data) {
    try {
      let resp = await axios({
        method: "GET",
        url: `${process.env.VUE_APP_ENDPOINT_BACKEND}/client/v2/shipment-orders/export`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          responseType: "application/vnd.ms-excel"
        },
        timeout: 300000,
        maxContentLength: 1073741824,
        responseType: "blob",
        params: data
      })
        .then(response => {
          let dataStr = fn.cutFileName(response.headers["content-disposition"]);
          let format = dataStr.split(".");
          format = format[format.length - 1];
          let url;
          if (response?.headers) {
            if (format == "xlsx") {
              url = window.URL.createObjectURL(new Blob([response.data]));
            } else if (format == "csv") {
              var BOM = "\uFEFF"; // utf-8 ใส่ตัวนี้
              url = window.URL.createObjectURL(new Blob([BOM + response.data]));
            } else {
              alert.error("export file ไมไ่ด้");
            }
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", dataStr);
            document.body.appendChild(link);
            link.click();
          }
        })
        .catch(err => {
          console.error(err.message, "message");
          return err.message;
        });
      if (typeof resp == "string") {
        return { status: false, data: {}, message: resp };
      } else {
        return { status: true, data: resp };
      }
    } catch (err) {
      console.error(err.message, "message");
    }
  },

  async exportCodApproval({ commit }, id) {
    try {
      let resp = await axios({
        method: "GET",
        url: `${process.env.VUE_APP_ENDPOINT_BACKEND}/client/v1/wallet/cod-approvals/${id}/shipment-orders/export`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          Accept: "application/json"
        },
        responseType: "blob",
        timeout: 300000,
        maxContentLength: 1073741824
      })
        .then(response => {
          let dataStr = fn.cutFileName(response.headers["content-disposition"]);
          let format = dataStr.split(".");
          format = format[format.length - 1];
          let url;
          if (response?.headers) {
            if (format == "xlsx") {
              url = window.URL.createObjectURL(new Blob([response.data]));
            } else if (format == "csv") {
              var BOM = "\uFEFF"; // utf-8 ใส่ตัวนี้
              url = window.URL.createObjectURL(new Blob([BOM + response.data]));
            } else {
              alert.error("export file ไมไ่ด้");
            }
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", dataStr);
            document.body.appendChild(link);
            link.click();
          }
        })
        .catch(err => {
          console.error(err.message, "message");
          return err.message;
        });
      if (typeof resp == "string") {
        return { status: false, data: {}, message: resp };
      } else {
        return { status: true, data: resp };
      }
    } catch (err) {
      console.error(err.message, "message");
    }
  },

  async dataGraph({ commit }, data) {
    try {
      let resp = await OrderService.apiGetdataGraph(data);
      return { status: true, ...resp };
    } catch (err) {
      console.error(err.message, "message");
    }
  },

  async getAccount({ commit }, data) {
    try {
      let resp = await OrderService.apiGetCustomer(data);
      return { status: true, ...resp };
    } catch (err) {
      console.error(err.message, "message");
    }
  },

  async DeleteAccount({ commit }, id) {
    try {
      let resp = await OrderService.apiDeleteAccount(id);
      return { status: true, ...resp };
    } catch (err) {
      console.error(err.message, "message");
    }
  },

  async printSentTo({ commit }, data) {
    try {
      let resp = await axios({
        method: "POST",
        url: `${process.env.VUE_APP_ENDPOINT_BACKEND}/client/v2/shipment-orders/proof-of-shipment-docs`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          Accept: "application/json"
        },
        responseType: "blob",
        data
      })
        .then(response => {
          window.open(URL.createObjectURL(response));
          return response;
        })
        .catch(err => {
          console.error(err.message, "message");
          return err.message;
        });

      if (typeof resp == "string") {
        return { status: false, data: {}, message: resp };
      } else {
        return { status: true, data: resp };
      }
    } catch (err) {
      console.error(err.message, "message");
    }
  },

  async getParcelHandoverDocument({ commit }, data) {
      const response = await axios({
        method: "POST",
        url: `${process.env.VUE_APP_ENDPOINT_BACKEND}/client/v2/shipment-orders/proof-of-shipment-docs`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          Accept: "application/json"
        },
        responseType: "blob",
        data: data
      })
      .then(data => {
        if (data instanceof Blob) {
          return data;
        }
        return false;
      })
      .catch(err => {
        console.error(err.message, "message");
        return false;
      });

      return response;
        
  },

  async createPickupOrder({ commit }, data) {
    try {
      let resp = await OrderService.apiCreatePickupOrder(data);
      return { status: true, ...resp };
    } catch (err) {
      return { status: false, err: err };
    }
  },

  async getPickupOrderByid({ commit }, id) {
    try {
      let resp = await OrderService.apiGetPickupOrderById(id);
      return { status: true, ...resp };
    } catch (err) {
      return { status: false, err: err };
    }
  },


  async getProductOnOrder({ commit }, id) {
    try {
      let resp = await OrderService.apiGetProductOnOrder(id);
      return { status: true, ...resp };
    } catch (err) {
      return { status: false, err: err };
    }
  }


  

};
